import { useI18n } from "@/i18n";

export const KIND_KEY = {
  bebas: "kind.free",
  tujuan: "kind.goal",
  sasaran: "kind.target",
  objektif: "kind.objective",
  jurnal: "kind.journal",
};

export const Chip = ({ active, label, testId, onClick }) => (
  <button
    type="button"
    aria-pressed={active}
    onClick={onClick}
    data-testid={testId}
    className={`inline-flex min-h-[44px] shrink-0 items-center rounded-[8px] border px-3 text-sm font-medium leading-5 transition-colors duration-150 ${
      active ? "tint-chip-active text-ax-link" : "border-ax-border bg-ax-surface text-ax-text hover:bg-ax-bg"
    }`}
  >
    {label}
  </button>
);

export const KindChips = ({ value, onChange, legend, testId, className = "" }) => {
  const { t } = useI18n();
  return (
    <fieldset data-testid={testId} className={`m-0 min-w-0 border-0 p-0 ${className}`}>
      <legend className="p-0 text-sm font-medium leading-5 text-ax-text">{legend}</legend>
      <div className="mt-2 flex flex-wrap gap-2">
        {Object.entries(KIND_KEY).map(([kind, key]) => (
          <Chip
            key={kind}
            active={value === kind}
            label={t(key)}
            testId={`${testId}-${kind}`}
            onClick={() => onChange(kind)}
          />
        ))}
      </div>
    </fieldset>
  );
};
